import React from 'react';
import { images } from '../data/salesCopy';
export function MethodIntro() {
  return <section className="bg-cream py-12 sm:py-24" aria-labelledby="metodo" data-id="element-61" data-mp="1rm4ys2raqqxo">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-62" data-mp="1rohhii4vp5bs">
        <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-16" data-id="element-63" data-mp="1wket6b575ni8">
          <div data-id="element-64" data-mp="20nkz1hoedco6">
            <p className="text-[10px] font-medium uppercase tracking-overline text-rose sm:text-[11px]" data-id="element-65" data-mp="20o4hczhym32q">
              Presentando
            </p>
            <h2 id="metodo" className="mt-4 font-display text-[1.85rem] font-semibold leading-tight text-ink sm:mt-5 sm:text-5xl" data-id="element-66" data-mp="25k1vr09nwzcv">
              El Método Nail-Elite: <span className="italic" data-id="element-67" data-mp="2fd0omuc6zc2a">Business-Art System</span>
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-ink/75 sm:mt-7 sm:text-lg" data-id="element-68" data-mp="2kbk9ssiyojtl">
              Es la primera metodología pensada para el mercado hispano que combina{' '}
              <span className="font-medium text-ink" data-id="element-69" data-mp="2tbqmwdaqzhs8">técnica de élite (soft gel y polygel)</span> con un{' '}
              <span className="font-medium text-ink" data-id="element-70" data-mp="3u3cqz0bn1oyb">sistema de marketing doméstico</span> que te llena
              la agenda en menos de 2 semanas, sin depender de las redes de un salón ajeno.
            </p>
            <p className="mt-5 border-l-2 border-champagne pl-4 font-display text-lg text-ink sm:mt-6 sm:pl-5 sm:text-2xl" data-id="element-71" data-mp="3l24vsr4f548g">
              No es un curso de uñas. Es tu sistema completo de libertad financiera desde casa.
            </p>
          </div>

          <img src={images.workspace} alt="Estudio de uñas en casa con lámpara LED profesional y geles ordenados sobre una mesa de mármol" className="aspect-[4/3] w-full rounded-3xl object-cover sm:aspect-[3/2]" loading="lazy" data-id="element-72" data-mp="hoainm5tupoc" />
        </div>
      </div>
    </section>;
}